import { render, staticRenderFns } from "./databaseList.vue?vue&type=template&id=7213d2f2&scoped=true&"
import script from "./databaseList.vue?vue&type=script&lang=js&"
export * from "./databaseList.vue?vue&type=script&lang=js&"
import style0 from "./databaseList.vue?vue&type=style&index=0&id=7213d2f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7213d2f2",
  null
  
)

component.options.__file = "databaseList.vue"
export default component.exports